import type { IconData } from '@stacksjs/iconify-core'

export const loadingHorizontal2: IconData = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\" d=\"M24 16a8 8 0 1 0 0 16a8 8 0 1 0 0-16M7 20a4 4 0 1 0 0 8a4 4 0 1 0 0-8m34 0a4 4 0 1 0 0 8a4 4 0 1 0 0-8\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default loadingHorizontal2
